import { render, staticRenderFns } from "./ModeratorDashboardTabs.vue?vue&type=template&id=31d2fd35&"
import script from "./ModeratorDashboardTabs.vue?vue&type=script&lang=js&"
export * from "./ModeratorDashboardTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports